export const LabelEnterpriseTrial = () => {
  return (
    <label className="nj-label-free nj-label-enterprise" data-e2e="label-tier-enterprise-trial">
      Enterprise Trial
    </label>
  );
};
